if (window.aicoScrollAnimationInitialized) {
} else {
  window.aicoScrollAnimationInitialized = true;

  const ANIMATION_CONFIG = {
    ".aico-similar-products-list": "0px 0px 30% 0px",
    ".aico-richtext": "0px 0px 10% 0px",
    ".aico-featured-product": "0px 0px -20% 0px",
    ".aico-custom": "0px 0px -20% 0px",
    ".aico-teaser": "0px 0px -20% 0px",
  };

  function initScrollAnimation() {
    const elements = [];
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    Object.entries(ANIMATION_CONFIG).forEach(([selector, rootMargin]) => {
      document.querySelectorAll(selector).forEach((element) => {
        let finalRootMargin = rootMargin;
        if (isMobile && selector === ".aico-similar-products-list") {
          finalRootMargin = "0px 0px 90% 0px";
        }
        elements.push({ element, rootMargin: finalRootMargin });
      });
    });

    if (!elements.length) return;

    const observers = {};

    elements.forEach(({ element, rootMargin }) => {
      if (!observers[rootMargin]) {
        observers[rootMargin] = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("aico-animate-in");
                observers[rootMargin].unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1, rootMargin }
        );
      }
      observers[rootMargin].observe(element);
    });
  }

  function startAnimation() {
    if (document.body) {
      initScrollAnimation();
    } else {
      setTimeout(startAnimation, 50);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startAnimation);
  } else {
    startAnimation();
  }
}
